module.exports = __webpack_public_path__ + "static/media/feat-chapter-img2.9e5eb654.jpg";